import HeaderContent, {
  HeaderContentProps,
} from "./layout/components/HeaderContent";
import React from "react";
import { List, ListProps } from "react-admin";
import styled from "styled-components";
import CustomPagination from "./CustomPagination";

interface ListWrapperProps extends ListProps, HeaderContentProps {
  children: React.ReactElement;
  denseMode?: boolean;
}

export const StyledList = styled(List)({
  backgroundColor: "transparent",
  "& .MuiTableCell-body": {
    padding: "30px 10px",
  },
  "& > div:first-child": {
    padding: "10px 28px 20px 28px",
    marginBottom: "20px",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    "& .MuiFilledInput-root": {
      border: 0,
      borderRadius: "30px",
      backgroundColor: "#F4F7FE !important",
      color: "#2B3674",
      "& .MuiSvgIcon-root": {
        color: "#2B3674", // Search icon color
      },
    },
  },
  "& > div:last-child": {
    padding: "10px 28px 20px 28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
  },
});

export const PaddingDenseStyledList = styled(List)({
  "& .MuiTableCell-body": {
    padding: "10px 10px",
  },
  backgroundColor: "transparent",
  "& > div:first-child": {
    padding: "10px 28px 20px 28px",
    marginBottom: "20px",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    "& .MuiFilledInput-root": {
      border: 0,
      borderRadius: "30px",
      backgroundColor: "#F4F7FE !important",
      "& .MuiInputBase-root": {
        "&:hover": {
          border: "0px !important",
        },
      },
      "& .MuiSvgIcon-root": {
        color: "#2B3674", // Search icon color
      },
      "& input": {
        color: "#2B3674",
      },
    },
    "& .MuiFormHelperText-root": {
      display: "none",
    },
  },
  "& > div:last-child": {
    padding: "10px 28px 20px 28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
  },
});

export const PaddingDenseStyled2List = styled(List)({
  "& .MuiTableCell-body": {
    padding: "10px 10px",
  },
  "& > div:first-child": {
    padding: "10px 28px 0px 28px",
    "& .MuiFilledInput-root": {
      border: 0,
      borderRadius: "30px",
      backgroundColor: "#F4F7FE !important",
      "& .MuiInputBase-root": {
        "&:hover": {
          border: "0px !important",
        },
      },
      "& .MuiSvgIcon-root": {
        color: "#2B3674", // Search icon color
      },
      "& input": {
        color: "#2B3674",
      },
    },
  },
  "& > div:last-child": {
    padding: "0px 28px 10px 28px",
  },
});

const ListWrapper: React.FC<ListWrapperProps> = (props) => {
  const {
    breadcrumb,
    headerTitle,
    isNotHaveSchoolFilter,
    denseMode,
    children,
    pagination,
    ...listProps
  } = props;

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle={headerTitle}
        isNotHaveSchoolFilter={isNotHaveSchoolFilter}
      />

      {denseMode ? (
        <PaddingDenseStyledList
          pagination={pagination ? pagination : <CustomPagination />}
          {...listProps}
        >
          {children}
        </PaddingDenseStyledList>
      ) : (
        <StyledList
          pagination={pagination ? pagination : <CustomPagination />}
          {...listProps}
        >
          {children}
        </StyledList>
      )}
    </>
  );
};

export default ListWrapper;
